import { CreditNoteRepository } from "../repositories/CreditNoteRepository";
import { CreditNoteOperationResult } from "../entities/CreditNoteEntity";

/**
 * Approve Credit Note Use Case
 * Approves a credit note
 */
export class ApproveCreditNoteUseCase {
  constructor(private repository: CreditNoteRepository) {}

  async execute(creditNoteId: number): Promise<CreditNoteOperationResult> {
    return await this.repository.approveCreditNote(creditNoteId);
  }
}
